import { v4 as uuidv4 } from 'uuid';

function setSearchText(text) {
    this.search.searchText = text;
    this.observed.search = uuidv4();
    this.applyDirectoryFilter();
}

export default setSearchText;
